namespace TabAurous.Purchase {
    export namespace ApprovalInReturnBOMService {
        export const baseUrl = 'PurchaseReturn/ApprovalInReturnBOM';

        export declare function Create(request: Serenity.SaveRequest<ApprovalInReturnBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalInReturnBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalInReturnBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInReturnBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PurchaseReturn/ApprovalInReturnBOM/Create",
            Update = "PurchaseReturn/ApprovalInReturnBOM/Update",
            Delete = "PurchaseReturn/ApprovalInReturnBOM/Delete",
            Retrieve = "PurchaseReturn/ApprovalInReturnBOM/Retrieve",
            List = "PurchaseReturn/ApprovalInReturnBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ApprovalInReturnBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
